<template>
  <div id="rodape">
    <b-container fluid class="py-5">
      <b-row>
        <b-col class="col-6 col-md-6 py-3 col-xl-3 align-self-center">
          <p>
            <img src="/img/logo_2.png" class="img-fluid" />
          </p>
          <p class="text-white">
            Av. Alm. Barroso, 700 - Marco,<br />
            Belém - PA, 66093-020
          </p>
        </b-col>
        <b-col class="col-6 col-md-6 py-3 col-xl-2 align-self-center">
          <p class="mb-0">
            <a class="text-white" href="http://www.finlev.com.br/"> Inicial </a>
          </p>
          <p class="mb-0">
            <a class="text-white" href="http://www.finlev.com.br/index/afinlev">
              A Finlev
            </a>
          </p>
          <p class="mb-0">
            <a
              class="text-white"
              href="http://www.finlev.com.br/index/solucoes"
            >
              Soluções
            </a>
          </p>
          <p class="mb-0">
            <a class="text-white" href="http://www.finlev.com.br/index/simule">
              Simule seu Crédito
            </a>
          </p>
          <p class="mb-0">
            <a class="text-white" href="http://www.finlev.com.br/index/duvidas">
              Dúvidas
            </a>
          </p>
          <p class="mb-0">
            <a
              class="text-white"
              href="http://www.finlev.com.br/index/politicaprivacidade"
            >
              Política de Privacidade
            </a>
          </p>
        </b-col>
        <b-col
          class="col-12 col-md-6 py-3 col-xl-4 align-self-center text-center"
        >
          <h6 class="text-center">
            <a
              href="<?= $this->oLinkApp->conteudo ?>"
              target="_blank"
              class="text-white"
            >
              <img src="/img/btn_banner_download_app_2.png" />
              <br /><br />
              Para empréstimos mais rápidos,<br>utilize o nosso web aplicativo.
            </a>
          </h6>
        </b-col>
        <b-col
          class="
            col-12 col-md-6
            py-3
            col-xl-3
            align-self-center
            text-center text-md-left
          "
        >
          <a href="#" target="_blank">
            <img src="/img/ico_whatsapp.png" />
          </a>

          <a href="#" target="_blank" class="px-3">
            <img src="/img/ico_face.png" />
          </a>

          <a href="#" target="_blank">
            <img src="/img/ico_insta.png" />
          </a>

          <div class="outer">
            <div class="media text-left pt-3">
              <img src="/img/ico_tel.png" class="mr-2 align-self-center" />
              <div
                class="media-body align-self-center"
                style="line-height: 15px"
              >
                <p class="mt-0 color-verde-4 mb-0">
                  <small>Atendimento</small>
                </p>
                <p class="text-white mb-0">0800 124 78 985</p>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "Rodape",
};
</script>

<style>
#rodape {
  background-color: #203d49;
}
</style>